// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"f2d2c814","29":"3afdc1f6","141":"f9a42082","341":"6752d1ed","371":"32e65726","467":"145652c4","500":"06e39613","666":"50fc6730","693":"99dae3e2","736":"9983240e","787":"5581c60d","811":"847375c3","948":"4529e03e","974":"0c31b822"}[chunkId] + ".chunk.js";
};